import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";

interface Flight {
    tailNumber: string;
    msn: string;
    fleetType: string;
    wifiProvider: string;
}

interface Crew {
    name: string;
    familyName: string;
    gender: string;
    email: string;
  }

  interface Email {
    value: string;
  }
  
  interface Phone {
    value: string;
  }  

interface PayloadData {
    org: {
      name: string;
      address: string;
      emails: string[];
      phoneNumbers: string[];
    };
    flights: Flight[];
    crews: Crew[];
    createdBy: string;
  }
  

export default class FormSubmit {
    static async createSubmitForm(
      leagalEntityName: string,
      address: string,
      emailArray: [],
      phoneNumberArray: [],
      crewMemArr2: [],
      airInfoArr1: [],
      userInfo: string
    ) {
      try {
        const payloadData: PayloadData = {
          org: {
            name: leagalEntityName,
            address: address,
            emails: (emailArray as { value: string }[]).map(
              (mail) => mail.value
            ),
            phoneNumbers: (phoneNumberArray as { value: string }[]).map(
              (phone) => phone.value
            ),
          },
          flights: airInfoArr1.map((flight: Flight) => ({
            tailNumber: (flight as any).Reg,
            msn: flight.msn,
            fleetType: flight.fleetType,
            wifiProvider: (flight as any).wifiPro,
          })),
          crews: crewMemArr2.map((crew: Crew) => ({
            name: (crew as any).firstname,
            familyName: (crew as any).lastName,
            gender: (crew as any).genderIdentity,
            email: crew.email,
          })),
          createdBy: userInfo,
        };
        const res = await fetch(APIs.BASE_URL+APIs.Form.submitForm.API, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payloadData),
        });
        return res;
      } catch (error) {
        console.error('Error submitting form:', error);
        throw error;
      }
    } 

    static async getAllFlightsWithoutLogin(){
      try{
        const res = await fetch(APIs.BASE_URL+APIs.Flight.GetAllFlights.API, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          body: null,
        });
        const jsonData = await res.json();
        return jsonData
      } catch (error) {
        console.error('Error fetching flights:', error);
        throw error;
      };
    }

    static async getWifiProviderWithoutLogin() {
      try{
        const res = await fetch(APIs.BASE_URL+APIs.Flight.GetWifiProvider.API, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          body: null,
        });
        const jsonData = await res.json();
        return jsonData;
      } catch (error) {
        console.error('Error fetching wifiProvider:', error);
        throw error;
      }
    }

    static async getAllForms() {
          try {
           
      
            const apiConfig = {
              api: APIs.Form.getAllForms,
              parameters: null,
              body: null,
            };
      
            const res = await SafeairManager.invoke(apiConfig);
            return res;
          } catch (error) {
            console.error('Error submitting form:', error);
            throw error;
          }
        }

        static async approveSelectedForm(id: string) {
              try {
                const apiConfig = {
                  api: APIs.Form.approveSelectedFrom,
                  parameters: {
                    "form_id": id,
                    "is_verified": true
                  },
                  body: null,
                };
          
                const res = await SafeairManager.invoke(apiConfig);
                return res;
              } catch (error) {
                console.error('Error submitting form:', error);
                throw error;
              }
            }

            static async getFormDataById(id: string) {
                  try {
                    const apiConfig = {
                      api: APIs.Form.getFormDataById,
                      parameters: {
                        "form-id": id
                      },
                      body: null,
                    };
              
                    const res = await SafeairManager.invoke(apiConfig);
                    return res;
                  } catch (error) {
                    console.error('Error submitting form:', error);
                    throw error;
                  }
                }

                static async getAllEventReport() {
                  try {
                    const apiConfig = {
                      api: APIs.Form.getAllEventReport,
                      parameters: null,
                      body: null,
                    };
              
                    const res = await SafeairManager.invoke(apiConfig);
                    return res;
                  } catch (error) {
                    console.error('Error submitting form:', error);
                    throw error;
                  }
                }
                static async getAllEventReportByOrgId(orgId: string) {
                  try {
                    if (!orgId) {
                      throw new Error("orgId is required but not provided.");
                    }
                
                    const apiConfig = {
                      api: APIs.Form.getAllEventReportByOrgId,
                      parameters: { orgId }, // ✅ Pass orgId here
                      body: null,
                    };
                
                    const res = await SafeairManager.invoke(apiConfig);
                    return res;
                  } catch (error) {
                    console.error("Error fetching event reports by Org ID:", error);
                    throw error;
                  }
                }
                
                
                static async getAllEventReportById(id: string) {
                  try {
                    const apiConfig = {
                      api: APIs.Form.getAllEventReportById,
                      parameters: {
                        "event-id": id
                      },
                      body: null,
                    };
              
                    const res = await SafeairManager.invoke(apiConfig);
                    return res;
                  } catch (error) {
                    console.error('Error submitting form:', error);
                    throw error;
                  }
                }
                static async ftfScreening(orgId: number, formUrl: string, questions: string[]) {
                  try {
                    const apiConfig = {
                      api: APIs.Form.ftfScreening, // API endpoint
                      parameters: null,
                      body:{
                        orgId: orgId,
                        formUrl:formUrl,
                        questions: questions, // Questions array as a JSON payload
                      },
                    };
                    
                    // Make the API call using SafeairManager.invoke
                    const res = await SafeairManager.invoke(apiConfig);
                    
                    return res;
                  } catch (error) {
                    console.error('Error submitting form:', error);
                    throw error;
                  }
                }


                static async showftfScreening() {
                  try {
                    const apiConfig = {
                      api: APIs.Form.showftfScreening,
                      parameters: null,
                      body: null,
                    };
              
                    const res = await SafeairManager.invoke(apiConfig);
                    return res;
                  } catch (error) {
                    console.error('Error submitting form:', error);
                    throw error;
                  }
                }

                static async showftfformbyuploadid(id: string) {
                  try {
                    const apiConfig = {
                      api: APIs.Form.showftfformbyuploadid,
                      parameters: {
                        "uploadid": id
                      },
                      body: null,
                    };
              
                    const res = await SafeairManager.invoke(apiConfig);
                    return res;
                  } catch (error) {
                    console.error('Error submitting form:', error);
                    throw error;
                  }
                }
                
  }